const operation = {
  DO: {
    list: '/operation/DO',
    create: '/operation/DO/new',
    update: id => `/operation/DO/update/${id}`
  },
  PO: {
    list: '/operation/PO',
    create: '/operation/PO/new',
    update: id => `/operation/po/update/${id}`
  },
  permit: {
    list: '/operation/permit',
    create: '/operation/permit/new',
    update: id => `/operation/permit/update/${id}`
  },
  // challan: {
  //   list: '/operation/challan',
  //   create: '/operation/challan/new',
  //   update: id => `/operation/challan/update/${id}`
  // },
  trips: {
    running_trip: '/trips/running-trips',
    breakdown_trip: '/trips/breakdown-trips',
    completed_trip: '/trips/completed-trips'
  }
};

export default operation;
